import * as types from './mutations-types'
import pointsMailApi from '../../../../../api/wx-member/points-mall/points-mall'

export default {
  productSearchInfo: ({commit}, data) => {
    pointsMailApi.productSearchInfo(data)
      .then(result => {
        commit(types.PRODUCT_HISTORY, result)
      })
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/product-search/store/actions.js